module.exports = __webpack_public_path__ + "static/media/international.55478ec2.svg";